import React from 'react';

import FeaturedContent from './FeaturedContent';
import type { FeaturedContentFeedProps } from './interfaces';

const ForYouFeaturedContentFeed = ({ contents }: FeaturedContentFeedProps) => {
  return (
    <div className="-mr-16 mt-32 flex flex-row flex-nowrap gap-32 overflow-x-auto pr-16 sm:mr-0 sm:flex-wrap sm:gap-y-72 sm:overflow-x-hidden sm:pr-0 nav:flex-nowrap">
      {contents.map((content) => (
        <FeaturedContent
          key={content.id}
          className="min-w-[65svw] !border-0 !px-0 !pb-0 sm:min-w-[calc(50svw-72px)] nav:min-w-0"
          featuredContent={content}
          isFluid
        />
      ))}
    </div>
  );
};

export default ForYouFeaturedContentFeed;
